import router, { resetRouter } from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from './utils/get-page-title'
import { menuUser } from './api/user.js'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist

let asyncRouter

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  // const hasToken = getToken()
  if (whiteList.indexOf(to.path) !== -1) {
    // in the free login whitelist, go directly
    next()
  } else {
    while (router.app.$keycloak.createLoginUrl === null) {
      await sleep(100)
    }
    if (router.app.$keycloak.authenticated) {
      if (!asyncRouter) {
        menuUser().then((res) => {
          asyncRouter = res.routes
          const permissions = res.permissions
          store.commit('account/setPermissions', permissions)
          store.commit('account/setRoutes', res.routes)
          resetRouter(res.routes)
          next({ ...to, replace: true })
        })
      } else {
        next()
      }
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl()
      window.location.replace(loginUrl)
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
